module.exports = {
	"_from": "truffle-contract-schema@0.0.5",
	"_id": "truffle-contract-schema@0.0.5",
	"_inBundle": false,
	"_integrity": "sha1-Xp0gvQvyon/pQxB0gknUhO7kmWE=",
	"_location": "/truffle-contract-schema",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "truffle-contract-schema@0.0.5",
		"name": "truffle-contract-schema",
		"escapedName": "truffle-contract-schema",
		"rawSpec": "0.0.5",
		"saveSpec": null,
		"fetchSpec": "0.0.5"
	},
	"_requiredBy": [
		"/truffle-contract"
	],
	"_resolved": "https://registry.npmjs.org/truffle-contract-schema/-/truffle-contract-schema-0.0.5.tgz",
	"_shasum": "5e9d20bd0bf2a27fe94310748249d484eee49961",
	"_spec": "truffle-contract-schema@0.0.5",
	"_where": "/Users/rafael/Documents/work/consensys/flight-tickets/node_modules/truffle-contract",
	"author": {
		"name": "Tim Coulter",
		"email": "tim.coulter@consensys.net"
	},
	"bugs": {
		"url": "https://github.com/trufflesuite/truffle-schema/issues"
	},
	"bundleDependencies": false,
	"dependencies": {
		"crypto-js": "^3.1.9-1"
	},
	"deprecated": false,
	"description": "JSON schema for contract artifacts",
	"devDependencies": {
		"mocha": "^3.2.0"
	},
	"homepage": "https://github.com/trufflesuite/truffle-schema#readme",
	"keywords": [
		"ethereum",
		"json",
		"schema",
		"contract",
		"artifacts"
	],
	"license": "MIT",
	"main": "index.js",
	"name": "truffle-contract-schema",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/trufflesuite/truffle-schema.git"
	},
	"scripts": {
		"test": "mocha"
	},
	"version": "0.0.5"
};


//////////////////
// WEBPACK FOOTER
// ./~/truffle-contract-schema/package.json
// module id = 436
// module chunks = 0